<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Produk yang menggunakan voucher ini'"
          :fields="fields"
          :items="data"
          :editButton="false"
          :redirectDetail="false"
          :removeButton="true"
          :enableAddButton="voucherStatus === '3' ? true : false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="6">
            <div class="form-group">
              <label for="voucher_seller">Pilih Seller</label>
              <model-select
                class="form-control"
                id="voucher_seller"
                :options="agentList"
                @input="callProduct"
                v-model="$v.voucherProductForm.agent_code.$model"
                :isError="$v.voucherProductForm.agent_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherProductForm.agent_code.$invalid"
                class="invalid-feedback-custom"
              >
                Agent should be filled.
              </div>
            </div>
          </CCol>

          <CCol sm="6">
            <div class="form-group">
              <label for="voucher_product"
                >Pilih produk yang ingin di berlakukan voucher</label
              >
              <model-select
                class="form-control"
                id="voucher_product"
                :options="productList"
                v-model="$v.voucherProductForm.product_code.$model"
                :isError="$v.voucherProductForm.product_code.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherProductForm.product_code.$invalid"
                class="invalid-feedback-custom"
              >
                Product should be filled.
              </div>
            </div>
          </CCol>

          <!-- <CCol sm="3">
                <CInput
                label="Price"
                invalid-feedback="price should be filled"
                required
                v-model="$v.priceForm.price.$model"
                :is-valid="!$v.priceForm.price.$invalid"
                />
            </CCol> -->
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.voucherProductForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "VoucherProduct",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Voucher Product",
      items: [],
      productList: [],
      filters: {
        agent_code: null,
      },
      addButton: false,
      isEdit: false,
      voucherProductForm: tableInterfaces.voucher_product,
      isLoading: false,
      image: null,
      activeTab: 0,
      fields: [
        { key: "product_code", label: "Product Code", sorter: true },
        { key: "name", label: "Product Name", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agentList: {
      type: [Array, Object],
      default: () => [],
    },
    voucher: {
      type: [Array, Object],
      default: () => [],
    },
    voucherProduct: {
      type: [Array, Object],
      default: () => [],
    },
    voucherStatus: {
      type: String,
      default: null,
    },
  },
  validations: {
    voucherProductForm: {
      agent_code: { required },
      product_code: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.voucherProduct;
    },
  },
  methods: {
    init: function () {
      this.$emit("update:");
    },

    // getProductList: function(){
    //     this.axios.get("/console/voucher/product-list").then((response) => {
    //     this.productList = response.data.data;
    //   });
    // },
    refreshVoucherProduct: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/voucher/voucher-product/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // if (response.data.total_row.total_row == 2) {
            //   this.enableAddPrice = false;
            // }
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    callProduct: function () {
      this.Loading = true;
      this.voucherProductForm.product_code = null;
      this.axios
        .get(
          "/console/dropdown/product/by-agent/" +
            this.voucherProductForm.agent_code
        )
        .then((response) => {
          this.productList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (item) {
      this.isEdit = true;
      //console.log(item);
      this.voucherProductForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.voucher_product) {
        tableInterfaces.voucher_product[i] = null;
      }
      this.voucherProductForm = tableInterfaces.voucher_product;
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.isLoading = false;
        this.axios
          .delete("console/voucher/remove/" + item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshVoucherProduct(this.voucher.id);
          });
      }
      // bikin api untuk remove
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.voucherProductForm.voucher_code = this.voucher.voucher_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put(
              "console/voucher/voucher-product/update",
              this.voucherProductForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherProduct(this.voucher.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post(
              "console/voucher/voucher-product/add",
              this.voucherProductForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherProduct(this.voucher.id);
            });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
